// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PrinterTwoToneSvg from "@ant-design/icons-svg/es/asn/PrinterTwoTone";
import AntdIcon from '../components/AntdIcon';

var PrinterTwoTone = function PrinterTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PrinterTwoToneSvg
  }));
};

PrinterTwoTone.displayName = 'PrinterTwoTone';
export default React.forwardRef(PrinterTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/PrinterTwoTone.js
// module id = 1617
// module chunks = 0